import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F8FAFC]">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="reset-form">
        <h2 className="font-head text-2xl font-bold text-slate-900">Set a new password</h2>
        <p className="text-sm text-slate-500 mb-6">Enter a new password for your account.</p>
        {!token && <div className="mb-4 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">Missing reset token. Use the link from your email.</div>}
        {error && <div className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>}
        <Label htmlFor="password">New password</Label>
        <Input id="password" type="password" required minLength={6} value={password}
               onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="reset-password-input" />
        <Button type="submit" disabled={loading || !token} className="w-full mt-6 bg-[#0B192C] hover:bg-[#142843]"
                data-testid="reset-submit-button">
          {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Reset password
        </Button>
        <div className="text-center mt-4">
          <Link to="/login" className="inline-flex items-center gap-1 text-sm text-[#E8791A] hover:underline">
            <ArrowLeft className="w-4 h-4" /> Back to sign in
          </Link>
        </div>
      </form>
    </div>
  );
}
